import {useTranslation} from '@/translations/i18n'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {ActivityReportCounters} from '@/features/accesses/activity-report/types'
import {StyledActivityReportCounterCard, StyledActivityReportCountersGrid} from './style'

type ActivityReportCountersPanelProps = {
    counters: ActivityReportCounters | undefined
    isLoading: boolean
}

export const ActivityReportCountersPanel = ({counters, isLoading}: ActivityReportCountersPanelProps) => {
    const {t} = useTranslation()

    if (isLoading) {
        return (
            <StyledActivityReportCountersGrid>
                {[0, 1].map(index => (
                    <StyledActivityReportCounterCard key={index}>
                        <Skeleton width={72} height={12} />
                        <Skeleton width={120} height={26} />
                        <Skeleton width={88} height={12} />
                    </StyledActivityReportCounterCard>
                ))}
            </StyledActivityReportCountersGrid>
        )
    }

    if (!counters) return null

    const accessesToValidate = Math.max(0, counters.totalAccesses - counters.validatedAccesses)
    const absencesToValidate = Math.max(0, counters.totalAbsences - counters.validatedAbsences)

    return (
        <StyledActivityReportCountersGrid>
            <StyledActivityReportCounterCard>
                <span className="label">{t('activity_report:counters_accesses')}</span>
                <strong>
                    {t('activity_report:counters_validated_of_total', {
                        validated: counters.validatedAccesses,
                        total: counters.totalAccesses
                    })}
                </strong>
                <span className="sublabel">
                    {t('activity_report:counters_to_validate', {value: accessesToValidate})}
                </span>
            </StyledActivityReportCounterCard>
            <StyledActivityReportCounterCard>
                <span className="label">{t('activity_report:counters_absences')}</span>
                <strong>
                    {t('activity_report:counters_validated_of_total', {
                        validated: counters.validatedAbsences,
                        total: counters.totalAbsences
                    })}
                </strong>
                <span className="sublabel">
                    {t('activity_report:counters_to_validate', {value: absencesToValidate})}
                </span>
            </StyledActivityReportCounterCard>
        </StyledActivityReportCountersGrid>
    )
}
